import styled from 'styled-components';
import LocationPin from "../../../../assests/images/location-pin-white.png";
import ReviewLocation from '../../../../assests/images/orange-location-box.svg';

export const SectionTitle = styled.div``;

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: bold; 
    line-height: 58px;
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        margin-bottom: 20px;
        font-size: 36px;
        line-height: 44px
    }
 
    @media screen and (max-width: 767px){
        font-size: 34px;
        line-height: 42px
    }

    @media screen and (max-width: 576px){
        font-size: 28px;
        line-height: 38px;
    }
`;

export const VoterWatchWrapper = styled.div`
    width: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
    padding: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    
    @media only screen and (max-width: 1200px){
        padding: 25px;
    }

    @media only screen and (max-width: 991px){
        align-items: flex-start;
        flex-direction: column;
        row-gap: 25px;
    }

    &::before{
        content: '';
        position: absolute;
        background: #70707057;
        width: 1px;
        max-height: 453px;
        margin: auto;
        top: 140px;
        bottom: 78px;
        left: 0;
        right: 0;
        @media screen and (max-width: 1024px){
            left: 19%;
        }
        @media screen and (max-width: 991px){
            display:none;
        }
    }
`;


export const VoterWatchBox = styled.div`
    width: calc(50% - 0px);
  

    @media only screen and (max-width: 1200px){
        padding-left: 0px;
    }
    @media screen and (max-width: 1024px){
        width: 60%;
    }
    @media screen and (max-width: 991px){
        width: 100%;
    }
`;
export const FoundationBox = styled.div`
    width: 100%;
    display: flex;
    gap: 20px;

    @media screen and (max-width: 479px){
        flex-direction: column;
    }
`;

export const FoundationImage = styled.div`
    background: #F7F7F7;
    box-shadow: 0px 10px 20px #0000001A;
    border-radius: 10px;
    opacity: 1;
    width: 120px;
    max-width: 120px;
    height: 120px;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const FoundationContent = styled.div`

`;

export const FoundationSubTitle = styled.h4`
    color: #333333;
    font-size: 16px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 14px;
`;

export const ReviewStart = styled.div`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 5px;
    margin-top: 10px;
`;

export const StarIcon = styled.div`
    width: 20px;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const ReviewText = styled.p`
    margin: 0;
`;

export const AddressHere = styled.div`
    width: 100%;
    max-width: 288px;
    background: #D3D3D3;
    color: #333333;
    font-size: 16px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 20px;
    margin-top: 20px;
    padding: 14px 10px 14px 46px;
    border-radius: 12px;
    position: relative;

    @media screen and (max-width: 479px){
        max-width: 100%;
    }

    &::before{
        content: '';
        position: absolute;
        background-image:url(${LocationPin});
        width: 24px;
        height: 24px;
        left: 12px;
        top:0;
        bottom:0;
        right: auto;
        margin: auto;
        border-radius: 50%;

        @media screen and (max-width: 479px){
            top: 11px;
        }
    }
    
`;

export const ButtonSection = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 24px;
    margin-top: 22px;

    @media screen and (max-width: 1100px){
        column-gap: 15px;
    }

    @media screen and (max-width: 575px){
        flex-wrap: wrap;
        gap: 15px;
    }
`;

export const VoterWatchButton = styled.button`
    &.btn-outline-success-blue{
        padding: 12px 20px;

        @media screen and (max-width: 390px){
            width: 100%;
        }
    }
`;

export const NonprofitsStatsGroup = styled.div`
    margin-top: 30px;
`;

export const NonprofitsStats = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 600;
    line-height:30px;
`;

export const NonprofitsStatsText = styled.p`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-top: 10px;
    margin-bottom: 0px;
`;

export const NonprofitsStatsSpan = styled.span``;


export const ReviewCounter = styled.ul`
    padding: 0;
    list-style: none;
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;
`;

export const ReviewCounterList = styled.li`
    
`;

export const ReviewListImage = styled.div`
    position: relative;
    width: 75px;
    text-align: center;
    vertical-align: middle;
    height: 67px;
    @media screen and (max-width: 360px){
        width: 65px;
    }
    
    img{
        width: 100%;
        max-width: 75px;
        height: 100%
    }

    &.rev-list-img-box{
        span{
            top: 8px;
        }
    }
    &.rev-list-img-heart{
        span{
            top: 18px;
        }
    }

    &.rev-list-img-Background{
        span{
            top: 18px;
        }
    }
`;

export const TextSpan = styled.span`
    position: absolute;
    margin: auto;
    top: 9px;
    bottom: 0;
    right: 0;
    left: 0;
    color: #FFFFFF;
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 600;
    line-height: 30px;

    @media screen and (max-width: 360px){
        font-size: 16px;
        line-height: 22px;
    }
`;

export const ReviewCounterText = styled.p`
    margin: 10px 0px 0px;
    color: #000000;
    font-size: 14px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
`;

export const LinkingText = styled.a`
    text-decoration: none;
    color: #01606F;
    font-size: 16px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;    
`;

export const RangeNonprofitStats = styled.div`
    margin-bottom: 20px;
    margin-top: 50px;
    &.rang-slider-review-pin .ant-tooltip{
        .ant-tooltip-inner{
            background-image:url(${ReviewLocation});
        }
      
    } 
    :where(.css-dev-only-do-not-override-17seli4).ant-tooltip .ant-tooltip-content{
        position: relative;
        font-size: 14px !important;
        font-family: 'Jost', sans-serif !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        background: #F7931E;
        color: #fff !important;
        width: 25px;
    }

    .ant-tooltip .ant-tooltip-content{
        &::before{
            position: absolute;
            top: 40%;
            left: 50%;
            margin-left: 115px;
            border-radius: 50%;
            border: 8px solid #F7931E;
            width: 8px;
            height: 8px;
            background: #F7931E;
        }
        &::after{
            position: absolute;
            content: '';
            width: 0px;
            height: 0px;
            bottom: -30px;
            left: -6px;
            border: 10px solid transparent;
            border-top: 17px solid #F7931E
        }
    }

    .rage-item{
        display: none;
    }
    .ant-slider-rail {
        height: 15px;
        max-width: 435px;
    }
    .ant-slider-track{
        height: 15px !important;
    }
    .review-no-counter{
        display: block;
    }
    .ant-slider {
        .ant-slider-handle{
            &::after{
                transition: none;
            }
        }
    }

    .ant-slider-handle{
        inset-inline-start: 0;
            inset-block-start: 0;
        &::before {
            box-shadow: none !important;
            border: none;
            border-radius: 0;
            transform: none;
            inset-inline-start: 0 !important;
            inset-block-start: 0 !important;
        }
        &::after{
            opacity: 0;
            inset-inline-start: 0 !important;
            inset-block-start: 0 !important;
        }
    }

    .ant-slider .ant-slider-handle:focus::after {
        inset-inline-start: 0 !important;
        inset-block-start: 0 !important;
    }
    .ant-slider .ant-slider-mark-text{
        opacity: 0px;
         font-size:0;
    }
    .ant-slider .ant-slider-mark-text-active{
        opacity: 1px;
        position: absolute;
        top: -27px;
        color: #fff;
        font-size: 14px;
        font-family: "Jost", sans-serif;
        
    }

    .ant-slider-horizontal{
        &.ant-slider-with-marks{
            max-width: 435px;
            width: 100%;
            margin-bottom: 20px;
        }
        .ant-slider-dot{
            position: absolute;
            inset-block-start: 0px;
            height: 15px;
            border-radius: 0;
            width: 1px;
            background: #70707057;
            top: 0;
            bottom: 0;
            border: 1px;
            &:first-child, &:last-child{
                background: transparent;
            }
        }
    }

    .ant-tooltip-content{
        position: relative;
       
    }

    .ant-slider-tooltip .ant-tooltip-inner{
        color: #333 !important;
        font-size: 14px !important;
        font-family: "Jost", sans-serif !important;
        font-weight: 400 !important;
        line-height: 20px !important;
    }

    .ant-slider .ant-slider-track{
        background-color: #33A7AE;
    }
`;


export const ReviewTextNumber = styled.div`
    color: #333;
    font-size: 16px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
`;

export const ReviewTextNumberSpan = styled.span`
    
`;


export const ProfileCompletionBox = styled.div`
    width: calc(50% - 0px);
    padding-left: 30px;
    @media only screen and (max-width: 1200px){
        padding-left: 25px;
    }
    @media screen and (max-width: 1024px){
        width: 30%;
    }
    @media screen and (max-width: 991px){
        width: 100%;
        padding-left: 0;
        padding-top: 25px;
        border-top: 1px solid #70707057;
    }
`;

export const ProfileCompletionProgressBar = styled.div`
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 30px;
    

    @media screen and (max-width: 1024px){
        align-items: flex-start;
        flex-direction: column;
        row-gap: 25px;
    }
    @media screen and (max-width: 991px){
        align-items: center;
        flex-direction: row;
        margin-top: 30px;
    }
    @media screen and (max-width: 575px){
        margin-top: 20px;
        column-gap: 20px;
        row-gap: 20px;
    }
    @media screen and (max-width: 479px){
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .ant-progress-inner {
        width: 255px !important;
        height: 255px !important;

        @media screen and (max-width: 575px){
            width: 160px !important;
            height: 160px !important;
        }
    }

    span.ant-progress-text {
        color: #333333 !important;
        font-size: 61px !important;
        font-family: 'Jost', sans-serif !important;
        font-weight: 400 !important;
        line-height: 88px !important;

        @media screen and (max-width: 575px){
            font-size: 34px !important;
            line-height: 44px !important;
        }
    }

    :where(.css-dev-only-do-not-override-17seli4).ant-progress .ant-progress-circle-trail {
        stroke: #D3D3D38C;
         strokeWidth: 4px;
    }

    :where(.css-dev-only-do-not-override-17seli4).ant-progress .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path{
        stroke: #33A7AE;
         strokeWidth: 4px;
    }
        :where(.css-17seli4).ant-progress .ant-progress-inner:not(.ant-progress-circle-gradient) .ant-progress-circle-path{
           stroke:rgb(51, 167, 174) !important;
         }
`;

export const ProfileCompletionCheckBox = styled.div`
    width: calc(50% - 0px);

    @media screen and (max-width: 1024px){
        width: 100%;
    }

    .profile-checkbox{
        width: 100%;
    }
    label.form-check-label{
        color: #000000;
        font-size: 14px;
        font-family: "Jost", sans-serif;
        font-weight: 400;
        line-height: 26px;
        padding-left: 12px;
    }
    .profile-checkbox-list {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        justify-content: flex-start;
        align-items: flex-start;

        @media only screen and (max-width: 1200px){
            row-gap: 15px;
        }
        
        @media only screen and (max-width: 479px){
            row-gap: 10px;
        }
    }
    .form-check{
        margin-bottom: 0;
    }
    .form-check-input{
        border: 1px solid #BABABA;
    }
    .form-check-input[type=checkbox] {
        border-radius: 0;
        width: 22px;
        height: 22px;
        cursor: pointer;
        margin: 0;
        @media  screen and (max-width: 575px){
            width: 16px;
            height: 16px;
        }
    }
    .form-check-input:checked {
        background-color: #33A7AE;
        border-color: #33A7AE;
        opacity: 1;

    }
    .form-check-input:focus{
        outline: 0;
        box-shadow: none;
    }
`;

export const CheckBoxLabelGroup = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 12px;
`;
export const FormCheckboxText = styled.label`
    color: #000;
    font-size: 14px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 20px;
    margin-top: 2px;

    @media only screen and (max-width: 1200px){
        margin-top: 0px;
    }
`;

export const FormCheckboxLink = styled.span`
    color:#33A7AE;
    font-size: 14px;
    cursor:pointer;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 20px;
    text-decoration: none;
`;

export const ProfileCheckboxList = styled.div`

`;

export const RatingHD = styled.div`
display: flex;
gap:10px;
.RatingReview{
    display: flex;
    width:151px
}
`;
